import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { getCaseId } from "../../../Utils/helper";
import { api_without_cancellation } from "../../../api/api";
import ChatSendingPopup from "../../Forms/common/ChatSendingPopup";
import UserChatBubble from "../../Forms/FirmUserBtn";
import PlaceHolderifNothingAdded from "../../components-new-final/placeholder-nothing-added";

export default function CaseWorkerSelection({
  case_users,
  case_users1,
  otherUser = [],
  uniqueIdUsers,
  assignedUsers,
  setAssignedUsers,
  setUniqueIdUsers,
  setBlurModal,
  panelLabel = "CASE WORKERS ASSIGNED TO CASE",
}) {
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  const [clickDates, setClickDates] = useState([]);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [successBtnFlag, setSuccessBtnFlag] = useState(false);
  const currentCase = getCaseId();
  const [chatData, setChatData] = useState(null);
  const [chatModal, setChatModal] = useState(false);

  const openChatModel = (event, data) => {
    event?.stopPropagation();
    setChatData(data);
    setChatModal(!chatModal);
  };

  // ── other users split into three columns (no role) ──────────────────────
  const otherUserColumns = useMemo(() => {
    const list = otherUser ?? [];
    const perCol = Math.ceil(list.length / 3);
    return [list.slice(0, perCol), list.slice(perCol, perCol * 2), list.slice(perCol * 2)];
  }, [otherUser]);

  useEffect(() => {
    setSuccessBtnFlag(assignedUsers.length === 0 ? false : true);
    if (clickDates.length === 0) {
      clickDatesAPI();
    }
  }, [assignedUsers]);

  async function clickDatesAPI() {
    try {
      const response = await api_without_cancellation.get("api/click_dates/", {
        params: { case_id: currentCase },
      });
      setClickDates(response.data);
    } catch (e) {
      console.error(e);
    }
  }

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!isInitialized && (case_users.length > 0 || case_users1.length > 0)) {
      // const allUserIds = [
      //   ...case_users.map((user) => user?.firm_user?.id),
      //   ...case_users1.map((user) => user?.firm_user?.id),
      // ].filter(Boolean);

      // setUniqueIdUsers(allUserIds);
      // setAssignedUsers(allUserIds);
      setIsInitialized(true);
    }
  }, [case_users, case_users1, isInitialized]);

  const toggleUserAssignment = (uniqueId, isChecked) => {
    if (isChecked) {
      setUniqueIdUsers([...uniqueIdUsers, uniqueId]);
      setAssignedUsers([...assignedUsers, uniqueId]);
    } else {
      const updatedAssignedUsers = assignedUsers.filter((id, idx) => {
        return id !== uniqueId || assignedUsers.indexOf(uniqueId) !== idx;
      });
      const updatedUniqueIdUsers = uniqueIdUsers.filter((id, idx) => {
        return id !== uniqueId || uniqueIdUsers.indexOf(uniqueId) !== idx;
      });

      setAssignedUsers(updatedAssignedUsers);
      setUniqueIdUsers(updatedUniqueIdUsers);
    }
  };

  // shared cell content: checkbox + chat bubble (no role)
  const renderUserCells = (user) => {
    const uniqueId = user?.firm_user?.id;
    return (
      <>
        <div className="d-flex  align-items-center justify-content-center">
          <div
            className="m-r-5 p-0 p-l-5"
            style={{
              width: "15px",
            }}
          >
            <input
              type="checkbox"
              className="form-check mb-0"
              data-user-id={user?.firm_user?.id}
              checked={uniqueIdUsers.includes(uniqueId)}
              onChange={(e) => toggleUserAssignment(uniqueId, e.target.checked)}
              style={{
                cursor: "pointer",
                minHeight: "15px",
              }}
            />
          </div>
          <div className="d-flex" style={{ height: "25px" }}>
            <button
              type="button"
              className="btn d-flex align-items-center justify-content-center padding-transform-visibility-margin p-0 flex-g"
              onClick={() => setBlurModal(true)}
            >
              <UserChatBubble
                first_name={user?.firm_user?.user?.first_name}
                last_name={user?.firm_user?.user?.last_name}
                profilePic={user?.firm_user?.user?.profile_pic_29p ?? ""}
                onClick={(e) => openChatModel(e, user)}
                isActive={userOnlineStatus?.[user?.firm_user?.user?.id]?.isOnline ?? false}
                is_active={user?.firm_user?.user?.is_active}
                width={19}
              />
            </button>
          </div>
        </div>
      </>
    );
  };

  // case-worker rows include the role column
  const renderUserRows = (users, suffix) =>
    users.map((user, index) => {
      const uniqueId2 = `${user?.firm_user?.id}-${index}-${suffix}`;
      const uniqueId = user?.firm_user?.id;

      return (
        <tr key={uniqueId2} className="height-25">
          <td
            style={{
              width: "25px",
            }}
          >
            <div className="d-flex align-items-center justify-content-center">
              <div className="">
                <input
                  type="checkbox"
                  className="form-check mb-0"
                  data-user-id={user?.firm_user?.id}
                  checked={uniqueIdUsers.includes(uniqueId)}
                  onChange={(e) => toggleUserAssignment(uniqueId, e.target.checked)}
                  style={{
                    cursor: "pointer",
                    minHeight: "13px",
                  }}
                />
              </div>
            </div>
          </td>
          <td
            className="text-start role-user-width "
            style={{
              minWidth: "150px",
            }}
          >
            <div className="d-flex  align-items-center justify-content-start">
              {user?.firm_user?.role?.name}
            </div>
          </td>
          <td className="td-autosize d-flex justify-content-end align-items-center w-100">
            <div className="d-flex p-r-5" style={{ height: "25px" }}>
              <button
                type="button"
                className="btn d-flex align-items-center justify-content-center padding-transform-visibility-margin p-0 flex-g"
                onClick={() => setBlurModal(true)}
              >
                <UserChatBubble
                  first_name={user?.firm_user?.user?.first_name}
                  last_name={user?.firm_user?.user?.last_name}
                  profilePic={user?.firm_user?.user?.profile_pic_29p ?? ""}
                  onClick={(e) => openChatModel(e, user)}
                  isActive={userOnlineStatus?.[user?.firm_user?.user?.id]?.isOnline ?? false}
                  is_active={user?.firm_user?.user?.is_active}
                  width={19}
                />
              </button>
            </div>
          </td>
        </tr>
      );
    });

  // other-user rows: no role column
  const renderOtherUserRows = (users) => users.map((user) => <>{renderUserCells(user)}</>);

  const TwoColumnTables = ({ col1, col2, idPrefix, suffix }) => (
    <div className="d-flex background-main-2 f-gap-05 mb-0">
      <div className="table-responsive table--no-card rounded-0 border-0 position-relative invisible-scrollbar">
        <table
          className="table table-borderless  has-height-25 has-table-sub-panel"
          id={`${idPrefix}-1`}
          style={{
            overflow: "hidden",
          }}
        >
          <tbody>{renderUserRows(col1, `${suffix}1`)}</tbody>
        </table>
      </div>

      <div className="table-responsive table--no-card rounded-0 border-0 position-relative invisible-scrollbar">
        <table
          className="table table-borderless  has-height-25 has-table-sub-panel"
          id={`${idPrefix}-2`}
          style={{
            overflow: "hidden",
          }}
        >
          <tbody>{renderUserRows(col2, `${suffix}2`)}</tbody>
        </table>
      </div>
    </div>
  );

  const ThreeColumnTables = ({ columns, idPrefix, suffix }) => (
    <div className="d-flex background-main-2 w-100 f-gap-05 mb-0">
      {columns.map((col, i) => (
        <div
          key={`${idPrefix}-${i}`}
          className="table-responsive d-flex-1 table--no-card rounded-0 border-0 position-relative invisible-scrollbar"
        >
          <table
            className="table table-borderless  has-height-25 has-table-sub-panel"
            id={`${idPrefix}-${i + 1}`}
            style={{
              overflow: "hidden",
            }}
          >
            <tbody>{renderOtherUserRows(col, `${suffix}${i + 1}`)}</tbody>
          </table>
        </div>
      ))}
    </div>
  );

  return (
    <div className="d-flex-column">
      <div className=" background-main-10 height-25 w-full">
        <h4 className="client-contact-title text-center height-25 d-flex justify-content-center align-items-center">
          {panelLabel}
        </h4>
      </div>

      {case_users?.length || case_users1?.length ? (
        <TwoColumnTables
          col1={case_users ?? []}
          col2={case_users1 ?? []}
          idPrefix="case-worker-id"
          suffix="caseuser"
        />
      ) : (
        <PlaceHolderifNothingAdded text1={"No Firm Users Attached to Case"} text2={""} />
      )}

      {otherUser && otherUser.length > 0 && (
        <>
          <div className=" background-main-10 height-25 w-full">
            <h4 className="client-contact-title text-center height-25 d-flex justify-content-center align-items-center">
              Add Reminder task for users not attached to case
            </h4>
          </div>

          <ThreeColumnTables
            columns={otherUserColumns}
            idPrefix="other-user-id"
            suffix="otheruser"
          />
        </>
      )}

      {chatModal && (
        <ChatSendingPopup
          data={chatData}
          show={chatModal}
          handleClose={() => {
            setChatModal(false);
          }}
          first_name={chatData?.firm_user?.user?.first_name}
          last_name={chatData?.firm_user?.user?.last_name}
          userId={chatData?.firm_user?.user?.id}
          is_active={chatData?.firm_user?.user?.is_active}
          profilePic={chatData?.firm_user?.user?.profile_pic_29p ?? ""}
        />
      )}
    </div>
  );
}
